import { useSyncExternalStore } from 'react';

/** Hero is a fixed full-screen layer. While visible, document scrolling is fully disabled. */
let visible = true;
const listeners = new Set<() => void>();

function applyScrollLock() {
  document.documentElement.classList.toggle('hero-layer-open', visible);
}

export function isHeroVisible() { return visible; }

export function setHeroVisible(v: boolean) {
  visible = v;
  applyScrollLock();
  listeners.forEach((l) => l());
}

function subscribe(l: () => void) {
  listeners.add(l);
  return () => { listeners.delete(l); };
}

/** Non-React subscription (used by in-page motion to wait until the Hero layer is gone). */
export function onHeroChange(l: () => void) { return subscribe(l); }

export function useHeroVisible() {
  return useSyncExternalStore(subscribe, isHeroVisible, () => true);
}